import React from 'react';
import { FC210 } from '../../../services/c212Api';
import { fmt3, calcPurchaseTotal } from '../helpers';

interface Tab2Props {
  formData: Partial<FC210>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FC210) => FC210[keyof FC210];
  setField: (key: keyof FC210, value: FC210[keyof FC210]) => void;
}

/**
 * Tab2: Page2 採購回應
 * BR-F02: Page2 is read-only during all edit modes (add/edit/copy).
 * Only editable in browse mode (which doesn't make sense for editing).
 * In practice, this tab is display-only for the main form.
 */
const Tab2PurchaseReply: React.FC<Tab2Props> = React.memo(({
  formData, names, isEditing, getField, setField,
}) => {
  // BR-F02: Page2 disabled in all edit modes
  const disabled = isEditing;

  const unitPrice = Number(getField('fc210_25')) || 0;
  const qty = Number(getField('fc210_26')) || 0;
  const total = calcPurchaseTotal(unitPrice, qty);

  return (
    <div className="tab-content-section">
      <div className="form-grid">
        <label>擬採購供應商</label>
        <input type="text" value={String(getField('fc210_24') || '')} style={{ width: 200 }}
          onChange={e => setField('fc210_24', e.target.value)}
          disabled={disabled} />

        <label>採購人員</label>
        <div className="lookup-field">
          <input type="text" value={String(getField('fc210_27') || '')} style={{ width: 80 }} maxLength={8}
            disabled={disabled}
            onChange={e => setField('fc210_27', e.target.value)} />
          <span className="lookup-name">{names.purchasePerson || ''}</span>
        </div>

        <label>採購單價</label>
        <input type="number" value={getField('fc210_25') as number || ''} style={{ width: 130 }}
          onChange={e => setField('fc210_25', parseFloat(e.target.value) || 0)}
          disabled={disabled} step="0.001" />

        <label>單位</label>
        <input type="text" value={String(getField('fc210_29') || '')} style={{ width: 60 }}
          onChange={e => setField('fc210_29', e.target.value)}
          disabled={disabled} />

        <label>擬採購數量</label>
        <input type="number" value={getField('fc210_26') as number || ''} style={{ width: 130 }}
          onChange={e => setField('fc210_26', parseFloat(e.target.value) || 0)}
          disabled={disabled} />

        <label>採購總額</label>
        <span className="lookup-display" style={{ fontWeight: 600 }}>{fmt3(total)}</span>
      </div>

      {/* Memo (BR-F02: disabled in edit mode) */}
      <div className="memo-group" style={{ marginTop: 16 }}>
        <label>回應說明</label>
        <textarea rows={5} style={{ width: '100%' }}
          value={String(getField('fc210_30') || '')}
          onChange={e => setField('fc210_30', e.target.value)}
          disabled={disabled} />
      </div>
    </div>
  );
});

Tab2PurchaseReply.displayName = 'Tab2PurchaseReply';
export default Tab2PurchaseReply;
